import ButtonSpinner from "components/Loading/ButtonSpinner";
import useProperties from "hooks/useProperties";
import React from "react";

const FilterButton = () => {
  const { properties, loading } = useProperties();

  return (
    <div className="p-4 border-t border-[#d5d7dd] ">
      <button className="bg-primary w-full text-white font-medium text-[14px] p-2 rounded-[6px] flex items-center justify-center uppercase hover:opacity-90 transition-all duration-200">
        {loading ? (
          <ButtonSpinner style={{ borderWidth: 3, width: 21, height: 21 }} />
        ) : properties.count > 0 ? (
          `vedi ${properties.count} annunci`
        ) : (
          "Nessun annuncio"
        )}
      </button>
    </div>
  );
};

export default FilterButton;
